import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';
import useCheckoutNavigation from 'utils/customHooks/useCheckoutNavigation';

const STEP_KEYS = ['cart', 'shipping', 'billing', 'payment'];

const CheckoutStepper = ({ activeStep, onStepClick }) => {
  const { t } = useTranslation(['cart']);
  const { goToStep } = useCheckoutNavigation();

  const getStepState = (index) => {
    if (index < activeStep) return 'completed';
    if (index === activeStep) return 'active';
    return 'pending';
  };

  const handleStepClick = (index) => {
    if (typeof onStepClick === 'function') {
      onStepClick(index);
      return;
    }
    goToStep(index);
  };

  return (
    <nav className="checkout-stepper" aria-label={t('checkoutProgress')}>
      <ol className="checkout-stepper__list">
        {STEP_KEYS.map((key, index) => {
          const state = getStepState(index);
          return (
            <li key={key} className="checkout-stepper__list-item">
              <button
                type="button"
                className={`checkout-stepper__item checkout-stepper__item--${state} checkout-stepper__item--clickable`}
                onClick={() => handleStepClick(index)}
                aria-current={index === activeStep ? 'step' : undefined}
              >
                <span className="checkout-stepper__badge" aria-hidden="true">
                  {state === 'completed' ? (
                    <FiCheck className="checkout-stepper__check" />
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="checkout-stepper__label">{t(key)}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

CheckoutStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func,
};

export default CheckoutStepper;
